<app-header login='yes'></app-header>
<div class="backgroundImage">
    <div class="container">
        <div class="d-flex justify-content-center h-100">
            <div class="responsive">
                <div class="card-wrapper">
                    <div class="sin-in-contnt">
                        <div class="sigin-screen-area"><span class="nav-divnk">Sign Up</span></div>
                        <div class="content-part">
                            <img src="assets/splash_logo.png">
                        </div>
                        <form class="form-signup" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                            <div class="form-group bg-eye-icon">
                                <input type="email" class="form-control" formControlName="email"
                                    placeholder="Enter email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <div *ngIf="f.email.errors.required">{{errorMessage}}</div>
                                    <div *ngIf="f.email.errors.email">{{emailMessage}}</div>
                                </div>
                            </div>

                            <div class="form-group bg-eye-icon">
                                <input [type]="fieldTextType ? 'text' : 'password'" class="form-control"
                                    formControlName="password" placeholder="New Password"
                                    [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                    <div *ngIf="f.password.errors.required">{{errorMessage}}</div>
                                    <div *ngIf="f.password.errors.minlength">{{passwordMessage}}</div>
                                </div>
                            </div>

                            <div class="form-group bg-eye-icon retype">
                                <input [type]="fieldTextType ? 'text' : 'password'" formControlName="confirmPassword"
                                    class="form-control retype-password" placeholder="Retype New Password"
                                    [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
                                <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                                    <div *ngIf="f.confirmPassword.errors.required">{{errorMessage}}</div>
                                    <div *ngIf="f.confirmPassword.errors.mustMatch">{{matchPassword}}</div>
                                </div>
                            </div>

                            <div class="form-check margin-b" style="text-align: end;">
                                <label class="form-check-label color">
                                    <input type="checkbox" class="form-check-input" value=""
                                        (change)="toggleFieldTextType()">Show Password
                                </label>
                            </div>


                            <div class="adjust-div sign-in-button">
                                <button type="submit" class="btn">Sign up</button>
                            </div>

                        </form>

                    </div>
                </div>
            </div>

        </div>
        <!-- <div class="sin-in-page-top">
            
        </div> -->
    </div>
</div>